<template>
  <div>
    <b-form-group
      label="Teklif Tarihi"
      label-for="odate"
    >
      <validation-provider
        #default="{ errors }"
        name="Teklif Tarihi"
        rules="required"
      >
        <b-form-datepicker
          id="edate"
          v-model="dataItem.odate"
          v-bind="{labelNoDateSelected: 'Teklif Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
          locale="tr"
          start-weekday="1"
          :disabled="offerData.id_confirmed_user !== null || dataItem.id_confirmed_user !== null || offerData.id_purchase_offer_status === '7' "
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'

export default {
  name: 'PurchaseOfferLinesOdate',
  components: {
    BFormGroup,
    BFormDatepicker,
    ValidationProvider,
  },
  data() {
    return {
      locale: 'tr',
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['purchaseOfferLines/dataItem']
    },
    offerData() {
      return this.$store.getters['purchaseOffers/dataItem']
    },
  },
  created() {
    localize(this.locale)
  },
}
</script>
<style scoped></style>
